var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "entity-administration-component-root" },
    [
      _vm._t("page-header", null, { items: _vm.items }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid p-0 mt-1 mb-3" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center justify-content-lg-start col-12 col-lg-4"
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary mb-3 mb-lg-0",
                  attrs: { type: "button" },
                  on: { click: _vm.addItem }
                },
                [_vm._v(_vm._s(_vm.$t("common.add")))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center col-12 col-lg-4" },
            [
              _vm.totalCount > _vm.pageRowsCount
                ? _c("pagination", {
                    attrs: {
                      "total-rows-count": _vm.totalCount,
                      "page-rows-count": _vm.pageRowsCount,
                      "showing-pages-count": 5
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center justify-content-lg-end col-12 col-lg-4"
            },
            [
              _c("label", { staticClass: "float-right mt-1" }, [
                _vm._v(_vm._s(_vm.$t("common.totalCount")) + ": "),
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.totalCount))
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "entity-administration-table-wrapper table-responsive" },
        [
          _vm.items
            ? _c("table", { staticClass: "table table-bordered table-sm" }, [
                _c("thead", { staticClass: "thead-light" }, [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.tableColumns, function(column, columnIndex) {
                        return _c(
                          "th",
                          {
                            key: column.name,
                            staticClass: "sorted-column align-middle",
                            on: {
                              click: [
                                function($event) {
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  )
                                    return null
                                  return _vm.setSortingBySingleColumn(
                                    columnIndex
                                  )
                                },
                                function($event) {
                                  if (!$event.ctrlKey) return null
                                  return _vm.addColumnForMulticolumnSorting(
                                    columnIndex
                                  )
                                }
                              ]
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center"
                              },
                              [
                                _c("div", [_vm._v(_vm._s(column.displayName))]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-1 d-flex align-items-center"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c("i", {
                                          class: _vm.getIconClass(columnIndex)
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.sortings.length > 1 &&
                                    _vm.getSortNumber(columnIndex) > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "text-primary ml-1" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getSortNumber(columnIndex)
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("th", { staticClass: "col-edit align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("common.actions")))
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.tableColumns, function(column, columnIndex) {
                        return _c(
                          "th",
                          { key: column.name, staticClass: "p-0 align-middle" },
                          [
                            _c("field-filter", {
                              key: columnIndex,
                              ref: "filterRef",
                              refInFor: true,
                              staticClass: "m-1",
                              attrs: {
                                index: columnIndex,
                                "field-name": column.displayName,
                                "column-name": column.name,
                                "entity-name": _vm.entityName,
                                "max-length": column.maxLength,
                                type: column.typeName,
                                "show-null-checkbox": _vm.hasNullableColumn,
                                "is-url": column.isUrl,
                                "is-nullable": column.isNullable,
                                "is-multiline": column.isMultiline,
                                "is-date-only": column.isDateOnly,
                                "select-values": column.selectValues,
                                "is-foreign-key": column.isForeignKey,
                                "display-name": _vm.getDisplayName(
                                  _vm.currentItem,
                                  column,
                                  ""
                                )
                              },
                              model: {
                                value: _vm.filters[columnIndex],
                                callback: function($$v) {
                                  _vm.$set(_vm.filters, columnIndex, $$v)
                                },
                                expression: "filters[columnIndex]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c("th", { staticClass: "align-middle" }, [
                        _vm.isFilters
                          ? _c("i", {
                              staticClass:
                                "fa fa-times fa-lg d-flex justify-content-center",
                              attrs: { title: _vm.$t("common.clearFilters") },
                              on: { click: _vm.resetFilters }
                            })
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.items, function(item) {
                    return _c(
                      "tr",
                      [
                        _vm._l(_vm.tableColumns, function(column) {
                          return _c(
                            "td",
                            [
                              !column.isUrl
                                ? [
                                    column.isMultiline
                                      ? [
                                          _c("pre", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getColumnValue(item, column)
                                              )
                                            )
                                          ])
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.getColumnValue(item, column)
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                  ]
                                : [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "_blank",
                                          href: _vm.getColumnValue(item, column)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getColumnValue(item, column)
                                          )
                                        )
                                      ]
                                    )
                                  ]
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        _c("td", { staticClass: "col-edit" }, [
                          _c("div", { staticClass: "align-content-center" }, [
                            _c("i", {
                              staticClass: "fa fa-edit mr-2",
                              attrs: { title: _vm.$t("common.edit") },
                              on: {
                                click: function($event) {
                                  return _vm.editItem(item)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-trash",
                              attrs: { title: _vm.$t("common.delete") },
                              on: {
                                click: function($event) {
                                  return _vm.deleteItem(item)
                                }
                              }
                            })
                          ])
                        ])
                      ],
                      2
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.info && _vm.showModal
        ? _c(
            "modal",
            {
              ref: "editItemsDialog",
              attrs: { title: _vm.title },
              on: {
                shown: function($event) {
                  _vm.isModalShown = true
                },
                hidden: function($event) {
                  _vm.isModalShown = false
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "okButton",
                    fn: function({ close }) {
                      return [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.save(close)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.ok")))]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                707761630
              )
            },
            [
              _c("template", { slot: "body" }, [
                _vm.currentItem
                  ? _c("form", [
                      _c(
                        "div",
                        { staticClass: "form-row" },
                        _vm._l(_vm.writableColumns, function(
                          column,
                          columnIndex
                        ) {
                          return _c("edit-field", {
                            key: columnIndex,
                            ref: "inputRef",
                            refInFor: true,
                            attrs: {
                              index: columnIndex,
                              "field-name": column.displayName,
                              "column-name": column.name,
                              "entity-name": _vm.entityName,
                              "max-length": column.maxLength,
                              type: column.typeName,
                              "is-url": column.isUrl,
                              "is-nullable": column.isNullable,
                              "is-multiline": column.isMultiline,
                              "is-date-only": column.isDateOnly,
                              "select-values": column.selectValues,
                              "is-foreign-key": column.isForeignKey,
                              "display-name": _vm.getDisplayName(
                                _vm.currentItem,
                                column,
                                ""
                              ),
                              "is-modal-shown": _vm.isModalShown
                            },
                            model: {
                              value: _vm.currentItem[column.name],
                              callback: function($$v) {
                                _vm.$set(_vm.currentItem, column.name, $$v)
                              },
                              expression: "currentItem[column.name]"
                            }
                          })
                        }),
                        1
                      )
                    ])
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("confirm-dialog")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }